// Centralized help content for search and navigation
export const helpTopics = [
  {
    id: "getting-started",
    title: "Getting Started",
    category: "Getting Started",
    description: "Learn how to navigate and use the portal",
    adminOnly: false,
    keywords: ["login", "dashboard", "navigation", "overview", "start"],
  },
  {
    id: "dashboard",
    title: "Dashboard Overview",
    category: "Getting Started",
    description: "Understanding your dashboard and widgets",
    adminOnly: false,
    keywords: ["dashboard", "widgets", "favorites", "executions", "kpi"],
  },
  {
    id: "runbooks-overview",
    title: "Runbooks Overview",
    category: "Runbooks",
    description: "What are runbooks and how to use them",
    adminOnly: false,
    keywords: ["runbook", "workflow", "automation", "execute"],
  },
  {
    id: "creating-runbooks",
    title: "Creating & Editing Runbooks",
    category: "Runbooks",
    description: "Step-by-step guide to creating runbooks",
    adminOnly: false,
    keywords: ["create", "edit", "runbook", "workflow builder"],
  },
  {
    id: "executing-runbooks",
    title: "Executing Runbooks",
    category: "Runbooks",
    description: "How to run runbooks and view results",
    adminOnly: false,
    keywords: ["execute", "run", "runbook", "history", "results"],
  },
  {
    id: "workflow-builder",
    title: "Workflow Builder",
    category: "Runbooks",
    description: "Visual workflow designer guide",
    adminOnly: false,
    keywords: ["workflow", "builder", "visual", "design", "steps"],
  },
  {
    id: "schedulers-overview",
    title: "Schedulers Overview",
    category: "Schedulers",
    description: "Automating runbook execution with schedules",
    adminOnly: false,
    keywords: ["scheduler", "schedule", "cron", "automation", "timing"],
  },
  {
    id: "creating-schedules",
    title: "Creating Schedules",
    category: "Schedulers",
    description: "Step-by-step guide to scheduling runbooks",
    adminOnly: false,
    keywords: ["create", "schedule", "cron", "timezone"],
  },
  {
    id: "variables-overview",
    title: "Variables Overview",
    category: "Variables",
    description: "Managing reusable data with variables",
    adminOnly: false,
    keywords: ["variables", "data", "storage", "reusable"],
  },
  {
    id: "managing-variables",
    title: "Managing Variables",
    category: "Variables",
    description: "Creating and editing variable data",
    adminOnly: false,
    keywords: ["create", "edit", "variables", "key", "value"],
  },
  {
    id: "connectors-overview",
    title: "Connectors Overview",
    category: "Connectors",
    description: "Understanding and using connectors",
    adminOnly: false,
    keywords: ["connectors", "authentication", "credentials", "api"],
  },
  {
    id: "managing-connectors",
    title: "Managing Connectors",
    category: "Connectors",
    description: "Creating and testing connectors",
    adminOnly: false,
    keywords: ["create", "edit", "test", "connectors", "authentication"],
  },
  {
    id: "user-management",
    title: "Managing Users",
    category: "User Management",
    description: "Viewing and editing user accounts",
    adminOnly: true,
    keywords: ["users", "admin", "edit", "manage", "accounts"],
  },
  {
    id: "invitations",
    title: "Inviting New Users",
    category: "User Management",
    description: "How to invite new users to the portal",
    adminOnly: true,
    keywords: ["invite", "invitation", "users", "admin", "new"],
  },
  {
    id: "permission-groups-overview",
    title: "Permission Groups Overview",
    category: "Permissions & Access",
    description: "Understanding the group-based permission system",
    adminOnly: true,
    keywords: ["permissions", "groups", "access", "control", "overview"],
  },
  {
    id: "creating-permission-groups",
    title: "Creating Permission Groups",
    category: "Permissions & Access",
    description: "Step-by-step guide to creating groups",
    adminOnly: true,
    keywords: ["create", "groups", "permissions", "new"],
  },
  {
    id: "assigning-permissions",
    title: "Assigning Permissions",
    category: "Permissions & Access",
    description: "Add permissions to groups",
    adminOnly: true,
    keywords: ["permissions", "assign", "groups", "access"],
  },
  {
    id: "managing-group-members",
    title: "Managing Group Members",
    category: "Permissions & Access",
    description: "Add and remove users from groups",
    adminOnly: true,
    keywords: ["users", "groups", "members", "add", "remove"],
  },
  {
    id: "assigning-runbooks-to-groups",
    title: "Assigning Runbooks to Groups",
    category: "Permissions & Access",
    description: "Control which runbooks groups can access",
    adminOnly: true,
    keywords: ["runbooks", "groups", "access", "assign"],
  },
  {
    id: "permission-lookups",
    title: "Permission Lookups",
    category: "Permissions & Access",
    description: "Using reverse lookup tools to find user permissions and runbook access",
    adminOnly: true,
    keywords: ["lookup", "reverse", "permissions", "users", "runbooks", "access", "search", "user permissions lookup", "runbook access lookup"],
  },
  {
    id: "audit-log",
    title: "Audit Log",
    category: "Security & Auditing",
    description: "Track and review all system activities, user actions, and security events",
    adminOnly: true,
    keywords: ["audit", "log", "security", "tracking", "history", "actions", "events", "compliance", "monitoring"],
  },
];

export const categories = [
  "Getting Started",
  "Runbooks",
  "Schedulers",
  "Variables",
  "Connectors",
  "User Management",
  "Permissions & Access",
  "Security & Auditing",
];
